import {DictWeapon, UpdateDictWeaponDto} from "../../../../model/Dto/Dict/Weapon";
import {ApiRequest, RequestMethod} from "../../../request";

export async function updateWeapon(id: string, data: UpdateDictWeaponDto): Promise<DictWeapon | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/weapon/${id}`);
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}